import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Button,
} from "reactstrap";

import { 
  DeliveryPlatformEnum,
  PriorityEnum,
  FrequencyEnum 
} from "./TipsEnum"; 

interface TipFormProps {
  validation: any;
  isEdit?: boolean;
  categories: any[];
  criteria: any[];
  deliveryMethods: any[];
}

const TipForm: React.FC<TipFormProps> = ({
  validation,
  isEdit = false,
  categories,
  criteria,
  deliveryMethods,
}) => {
  return (
    <form onSubmit={validation.handleSubmit}>
      <div className="px-3 py-2">
        <h5>{isEdit ? "Edit Tip" : "New Tip"}</h5>
        <Row className="g-3 mt-2">
          <Col md={12}>
            <Label>Tip Title <span className="text-danger">*</span></Label>
            <Input
              name="tip_title"
              value={validation.values.tip_title}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.tip_title && validation.errors.tip_title)}
              placeholder="Enter Tip Title..."
              disabled={isEdit}   
              style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
            />
            <FormFeedback>{validation.errors.tip_title}</FormFeedback>
          </Col>
           <Col md={12}>
            <Label>Tip Content <span className="text-danger">*</span></Label>
            <div className="position-relative">
              <Input
                type="textarea"
                rows={3}
                name="tip_content"
                maxLength={70}   
                value={validation.values.tip_content}
                onChange={validation.handleChange}
                invalid={!!(validation.touched.tip_content && validation.errors.tip_content)}
                placeholder="Enter Tip Content..."
              />
              <FormFeedback>{validation.errors.tip_content}</FormFeedback>
              <div
                style={{
                  position: "absolute",
                  bottom: "6px",
                  right: "12px",
                  fontSize: "12px",
                  color: "#6c757d",
                }}
              >
                {validation.values.tip_content.length}/70
              </div>
            </div>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Category <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="category_id"
              value={validation.values.category_id}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.category_id && validation.errors.category_id)}
              disabled={isEdit}   
              style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
            >
             <option value="" disabled hidden>Select Category</option>
              {(Array.isArray(categories) ? categories : []).map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.category_name}
                </option>
              ))}
            </Input>
            <FormFeedback>{validation.errors.category_id}</FormFeedback>
          </Col>
          <Col md={6}>
            <Label>Frequency</Label>
            <Input
              type="select"
              name="frequency"
              value={validation.values.frequency}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.frequency && validation.errors.frequency)}
              // disabled={isEdit}   
              // style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
            >
              <option value="" disabled hidden>Select Frequency</option>
              <option value={FrequencyEnum.Daily}>Daily</option>
              <option value={FrequencyEnum.Weekly}>Weekly</option>
              <option value={FrequencyEnum.Monthly}>Monthly</option>
              <option value={FrequencyEnum.Custom}>Custom</option>

            </Input>
            <FormFeedback>{validation.errors.frequency}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Criteria <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="criteria_id"
              value={validation.values.criteria_id}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.criteria_id && validation.errors.criteria_id)}
              disabled={isEdit}   
              style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
            >
              <option value="" disabled hidden>Select Criteria</option>
              {(criteria || []).map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.criteria_name}
                </option>
              ))}
            </Input>
            <FormFeedback>{validation.errors.criteria_id}</FormFeedback>
          </Col>
          <Col md={6}>
            <Label>Delivery Method <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="delivery_method_id"
              value={validation.values.delivery_method_id}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.delivery_method_id && validation.errors.delivery_method_id)}
              disabled={isEdit}   
              style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
              >
              <option value="" disabled hidden>Select Delivery Method</option>
              {(deliveryMethods || []).map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.method_name}
                </option>
              ))}
            </Input>
            <FormFeedback>{validation.errors.delivery_method_id}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Priority <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="priority"
              value={validation.values.priority}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.priority && validation.errors.priority)}
              disabled={isEdit}   
              style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
              >
              <option value={PriorityEnum.Low}>Low</option>
              <option value={PriorityEnum.Medium}>Medium</option>
              <option value={PriorityEnum.High}>High</option>
            </Input>
            <FormFeedback>{validation.errors.priority}</FormFeedback>
          </Col>
          <Col md={6}>
          <Input
            type="hidden"
            name="delivery_platform"
            value={DeliveryPlatformEnum.App}   // or simply "Admin"
            onChange={validation.handleChange}
            disabled={isEdit}   
            style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
          />
          </Col>
        </Row>
        {validation.values.frequency === FrequencyEnum.Custom && (
          <Row className="g-3 mt-2">
            <Col md={6}>
              <Label>Start Date <span className="text-danger">*</span></Label>
              <Input
                type="date"
                name="start_date"
                value={validation.values.start_date}
                onChange={validation.handleChange}
                
              />
            </Col>

            <Col md={6}>
              <Label>End Date <span className="text-danger">*</span></Label>
              <Input
                type="date"
                name="end_date"
                value={validation.values.end_date}
                onChange={validation.handleChange}
              />
            </Col>
          </Row>
        )}

        <div className="d-flex justify-content-end mt-4">
          <Button color="primary" type="submit">
            {isEdit ? "Update Tip" : "Create Tip"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default TipForm;
